import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import swal from 'sweetalert';
import Modal from './vendedoresModal';
import { notificationError } from '../empresasComponentes/EmpresasNotify';
import { notificationSuccess } from '../empresasComponentes/EmpresasNotify';
import { BotonAdd, BotonEditar } from '../Plantillas/Botones';

const VendedoresListaContainer = () => {
    const [vendedores, setVendedores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [vendedorEdit, setVendedorEdit] = useState({ IdVendedor: null, RazonSocial: '', NroDocumento: '', Activo: 1 });

    const fetchVendedores = async () => {
        setLoading(true);
        try {
            const res = await fetch('/api/vendedores');
            const data = await res.json();

            if (Array.isArray(data)) {
                setVendedores(data);
            } else {
                setVendedores([]);
                if (data.error) {
                    notificationError('Error al cargar vendedores');
                }
            }
        } catch (error) {
            notificationError('Error al cargar vendedores');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVendedores();
        const interval = setInterval(fetchVendedores, 5000);
        return () => clearInterval(interval);
    }, []);

    const handleEdit = (vendedor) => {
        setVendedorEdit({
            IdVendedor: vendedor.IdVendedor,
            RazonSocial: vendedor.RazonSocial || '',
            NroDocumento: vendedor.NroDocumento || '',
            Activo: vendedor.Activo
        });
        setModalIsOpen(true);
    };

    const handleAdd = () => {
        setVendedorEdit({ IdVendedor: null, RazonSocial: '', NroDocumento: '', Activo: 1 });
        setModalIsOpen(true);
    };

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const handleSave = async (e) => {
        e.preventDefault();

        // if (vendedorEdit.IdVendedor) {
        //     const confirm = await swal({
        //         title: "¿Está seguro?",
        //         text: "¿Desea actualizar los datos del vendedor?",
        //         icon: "warning",
        //         buttons: ["Cancelar", "Aceptar"],
        //         dangerMode: false,
        //     });
        //     if (!confirm) return;
        // }

        const method = vendedorEdit.IdVendedor ? 'PUT' : 'POST';
        const url = vendedorEdit.IdVendedor ? `/api/vendedores/actualizar/${vendedorEdit.IdVendedor}` : '/api/vendedores/crear';

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(vendedorEdit)
            });
            const data = await res.json();

            if (data.respuesta) {
                notificationSuccess(vendedorEdit.IdVendedor ? 'Vendedor actualizado con éxito' : 'Vendedor registrado con éxito');
                handleCloseModal();
                fetchVendedores();
            } else {
                throw new Error(data.error || 'Error en el servidor');
            }
        } catch (error) {
            notificationError('Error al guardar vendedor');
        }
    };

    const columns = [
        {
            Header: 'Acciones',
            filterable: false,
            sortable: false,
            width: 100,
            Cell: ({ original }) => (
                <div className="text-center">
                    <BotonEditar onClick={() => handleEdit(original)} title="Editar Vendedor" />
                </div>
            )
        },
        {
            Header: 'RUC/DNI',
            accessor: 'NroDocumento',
            filterable: true,
            width: 150,
            className: "text-center"
        },
        {
            Header: 'Razon Social',
            accessor: 'RazonSocial',
            filterable: true,
            className: "text-center"
        },
        {
            Header: 'Estado',
            accessor: 'Activo',
            width: 150,
            className: "text-center",
            Cell: ({ value }) => (
                <span className={`badge badge-${value ? 'success' : 'danger'}`}>
                    {value ? 'ACTIVO' : 'INACTIVO'}
                </span>
            )
        }
    ];

    return (
        <section className='ventas-fpay-section-vh cienvh pt-5'>
            <div className='container'>
                <div align="right" className="seccion-btn-verde-mfp pt-3">
                    <BotonAdd onClick={handleAdd} className="btn btn-verde-mfp">
                        Crear Vendedor
                    </BotonAdd>
                </div>
                <div className="pt-3">
                    <ReactTable
                        data={vendedores}
                        columns={columns}
                        loading={loading}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        loadingText="Cargando..."
                        noDataText="No se encontraron registros"
                        pageText="Página"
                        ofText="de"
                        rowsText="filas"
                        style={{ fontSize: "15px" }}
                        pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                    />
                </div>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onClose={handleCloseModal}
                title={vendedorEdit.IdVendedor ? "MODIFICAR VENDEDOR: " + vendedorEdit.RazonSocial : "NUEVO VENDEDOR"}
            >
                <form onSubmit={handleSave}>
                    <div className="form-group text-left">
                        <label className="font-weight-bold">RUC/DNI:</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Ingrese el numero Documento"
                            value={vendedorEdit.NroDocumento}
                            onChange={(e) => setVendedorEdit({ ...vendedorEdit, NroDocumento: e.target.value })}
                            required
                        />
                    </div>
                    <div className="form-group text-left">
                        <label className="font-weight-bold">Razon Social:</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Ingrese el nombre completo"
                            value={vendedorEdit.RazonSocial}
                            onChange={(e) => setVendedorEdit({ ...vendedorEdit, RazonSocial: e.target.value })}
                            required
                        />
                    </div>
                    {vendedorEdit.IdVendedor && (
                        <div className="form-group text-left">
                            <label className="font-weight-bold">Estado:</label>
                            <select
                                className="form-control"
                                value={vendedorEdit.Activo}
                                onChange={(e) => setVendedorEdit({ ...vendedorEdit, Activo: parseInt(e.target.value) })}
                            >
                                <option value={1}>ACTIVO</option>
                                <option value={0}>INACTIVO</option>
                            </select>
                        </div>
                    )}
                    <div className="modal-footer pt-3">
                        <button type="button" onClick={handleCloseModal} className="btn btn-secondary mr-2">Cancelar</button>
                        <button type="button" onClick={handleSave} className="btn btn-primary">
                            {vendedorEdit.IdVendedor ? 'Actualizar' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </Modal>
        </section>
    );
};

export default VendedoresListaContainer;
